module.exports = __webpack_public_path__ + "img/success.ce31ed4c.png";